import Glider from '../../../js/glider'

const Gallery = {

  init: function (element) {
    const _ = this
    const gliderElement = element.querySelector('.glider')
    const modal = element.querySelector('.gallery__modal')
    const closeButton = element.querySelector('.gallery__modal-close-button')

    if (closeButton != null) {
      closeButton.addEventListener('click', (e) => {
        _.Modal_Close(modal)
      })
    }

    if (modal != null) {
      modal.addEventListener('click', (e) => {
        if (e.target.classList.contains('gallery__modal')) {
          _.Modal_Close(modal)
        }
      })
    }

    const glider = new Glider(gliderElement, {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      arrows: {
        prev: element.querySelector('.glider-prev'),
        next: element.querySelector('.glider-next')
      }
    })

    const thumbnails = element.querySelectorAll('.gallery__thumbnail-image')
    for (let i = 0; i < thumbnails.length; ++i) {
      thumbnails[i].addEventListener('click', (e) => {
        _.Modal_Open(modal, i, glider)
        glider.resize()
      })
    }
  },
  Modal_Open: (modal, slideId, glider) => {
    document.querySelector('body').classList.add('no-scroll')
    modal.classList.add('open')
    modal.attributes['aria-hidden'].value = 'false'
    glider.scrollItem(slideId)
  },
  Modal_Close: (modal) => {
    document.querySelector('body').classList.remove('no-scroll')
    modal.classList.remove('open')
    modal.attributes['aria-hidden'].value = 'true'
  }
}

export default Gallery
